import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import brandLogo from '../Images/dochoice-m1.png';

const productLinks = [
  { title: 'Hospital HMS', href: '/products#hms' },
  { title: 'Laboratory Information System', href: '/products#lis' },
  { title: 'Pharmacy Management', href: '/products#pharmacy' },
  { title: 'Machine Integrations', href: '/products#machine-integration' },
  { title: 'Cloud & On-Premise', href: '/products#cloud-services' },
];

const companyLinks = [
  { title: 'About Us', href: '/about' },
  { title: 'Contact Us', href: '/contact' },
  { title: 'Appointment / Book Demo', href: '/appointments' },
  { title: 'Privacy Policy', href: '/?page=privacy' },
  { title: 'Terms & Conditions', href: '/?page=terms' },
];

const whyItems = [
  { title: 'ABDM Ready', icon: 'lucide:shield-check' },
  { title: 'ISO 27001 Certified', icon: 'lucide:badge-check' },
  { title: '24/7 Local Support', icon: 'lucide:headset' },
  { title: 'Made in India', icon: 'lucide:flag' },
];

export default function Footer() {
  return (
    <footer className="cs_site_footer">
      <div className="cs_site_footer_main">
        <div className="container">
          <div className="cs_site_footer_grid">
            <div className="cs_site_footer_brand">
              <Link to="/" className="cs_site_footer_logo">
                <img
                  src={brandLogo}
                  alt="DocChoice by Moka Softwares"
                  className="cs_site_footer_logo_img"
                  decoding="async"
                />
                <span className="cs_site_footer_brand_copy">
                  <span className="cs_site_footer_brand_name">
                    <span className="cs_site_footer_brand_doc">Doc</span>
                    <span className="cs_site_footer_brand_choice">Choice</span>
                  </span>
                  <small>by Moka Softwares</small>
                </span>
              </Link>
              <p>
                One intelligent platform for hospitals, clinics, diagnostic
                centers, and pharmacies.
              </p>
            </div>

            <div className="cs_site_footer_col">
              <h4>PRODUCTS</h4>
              <ul>
                {productLinks.map((item) => (
                  <li key={item.title}>
                    <Link to={item.href}>{item.title}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="cs_site_footer_col">
              <h4>COMPANY</h4>
              <ul>
                {companyLinks.map((item) => (
                  <li key={item.title}>
                    <Link to={item.href}>{item.title}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="cs_site_footer_col">
              <h4>WHY DOCCHOICE</h4>
              <ul className="cs_site_footer_why">
                {whyItems.map((item) => (
                  <li key={item.title}>
                    <Icon icon={item.icon} width={16} height={16} aria-hidden="true" />
                    {item.title}
                  </li>
                ))}
              </ul>
            </div>

            <div className="cs_site_footer_col">
              <h4>GET IN TOUCH</h4>
              <ul className="cs_site_footer_contact">
                <li>
                  <Icon icon="lucide:map-pin" width={16} height={16} aria-hidden="true" />
                  <span>
                    #10, 2nd Street, Gandhi Nagar,
                    <br />
                    Bellary, Karnataka - 583101
                  </span>
                </li>
                <li>
                  <Icon icon="lucide:phone" width={16} height={16} aria-hidden="true" />
                  <span className="cs_site_footer_phones">
                    <a href="tel:+917259034852">+91-7259034852</a>
                    <a href="tel:+919164981600">+91-9164981600</a>
                  </span>
                </li>
                <li>
                  <Icon icon="lucide:mail" width={16} height={16} aria-hidden="true" />
                  <a href="mailto:support@mokasoftwares.com">
                    support@mokasoftwares.com
                  </a>
                </li>
                <li>
                  <Icon icon="lucide:globe" width={16} height={16} aria-hidden="true" />
                  <a
                    href="https://www.mokasoftwares.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    www.mokasoftwares.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="cs_site_footer_bottom">
        <div className="container">
          <div className="cs_site_footer_bottom_in">
            <p>© 2026 Moka Softwares. All Rights Reserved.</p>
            <p>Designed &amp; Engineered by the DocChoice Team</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
